/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Radio, NS/Tractie radio-pendant overrides.
// Tractie source: radio. Inner-dot gebruikt success-cluster bg.
//
// Token references (Tractie -> NS):
//   - default border:    --tractie-color-border-input-default     -> --ns-color-border-input-default (cluster 3)
//   - hover border:      --tractie-color-border-input-hover       -> --ns-color-border-input-hover   (cluster 3)
//   - checked border:    --tractie-color-border-success           -> --ns-color-border-success       (cluster 3, Q2)
//   - inner-dot bg:      --tractie-color-background-success-default -> --ns-color-bg-success-default (cluster 1, Q2)
//   - outer bg checked:  --tractie-color-background-default       -> --ns-color-bg-default           (cluster 1)
//   - icon-size:         1rem                                     -> --ns-control-icon-size-s        (cluster 13)
//
// MUI v4 Radio DOM: <span class="MuiRadio-root"><span class="MuiIconButton-label">
//   <svg class="MuiSvgIcon-root">RadioButtonUnchecked</svg>
//   <svg class="MuiSvgIcon-root">RadioButtonChecked</svg>
// </span></span>. MUI gebruikt SVG-icons (geen pseudo-elementen). Color-property
// stuurt zowel outer-circle als inner-dot via SVG-fill = currentColor.
//
// MUI default: colorPrimary checked = primary.main (blauw). Tractie deviation Q2: success-green.
// MUI default: hover-tint rgba(0,0,0,0.04). Tractie deviation: geen bg-tint, alleen border.

export const MuiRadioLightOverrides = {
  root: {
    color: 'var(--ns-color-border-input-default)',
    padding: 'var(--ns-space-1)',
    '&:hover': {
      backgroundColor: 'transparent',
      color: 'var(--ns-color-border-input-hover)',
    },
    '&$disabled': {
      opacity: 0.5,
      pointerEvents: 'none' as const,
    },
  },

  // Q2: checked-state = success-cluster (Tractie-spec). MUI's color-prop drives
  // both outer-circle stroke en inner-dot fill via currentColor in SVG-icons.
  //
  // IconButton leak (the same one Checkbox resets): MUI v4 Radio renders
  // an IconButton, so a radio with color="primary" (RJSF's RadioWidget) or the
  // default "secondary" also carries MuiIconButton-colorPrimary/-colorSecondary.
  // That override fills it with --ns-color-bg-interactive-default, a blue 40x40
  // square, and on :active with the -pressed blue. Firefox puts :active on the radio
  // itself during a keyboard press (Chrome and WebKit do not), so both need a reset.
  // Colour and hover need none: root's rules already win over the IconButton ones,
  // and a mouse press always carries :hover (measured in Storybook).
  colorPrimary: {
    backgroundColor: 'transparent',
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&$checked': {
      color: 'var(--ns-color-bg-success-default)',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '&$disabled': {
      opacity: 0.5,
    },
  },

  colorSecondary: {
    backgroundColor: 'transparent',
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&$checked': {
      color: 'var(--ns-color-bg-success-default)',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '&$disabled': {
      opacity: 0.5,
    },
  },

  checked: {},
  disabled: {},
} as const;

// Dark spreads Light: token-driven (success-cluster mode-flipt via tokens.css).
export const MuiRadioDarkOverrides = {
  ...MuiRadioLightOverrides,
} as const;
